import React from 'react';
import { observer } from 'mobx-react';
import { clientStore } from 'apps/client/app';
import {
  SpacingToAvoidFrameMobile,
  SpacingToAvoidFrameDesktop,
} from './spacingToAvoidFrame.styled';

type SpacingToAvoidFrameProps = {
  active?: boolean;
  children?: React.ReactNode;
};

const SpacingToAvoidFrame = observer(
  ({ active, children }: SpacingToAvoidFrameProps) => {
    const SpacingToAvoidFrameComponent = clientStore.isMobile
      ? SpacingToAvoidFrameMobile
      : SpacingToAvoidFrameDesktop;
    return (
      <SpacingToAvoidFrameComponent active={active}>
        {children}
      </SpacingToAvoidFrameComponent>
    );
  },
);

export default SpacingToAvoidFrame;
